import { z } from "zod";

export const isValidSelectorString = (errorMessage: string) => {
  return z.object(
    {
      value: z.string({ required_error: errorMessage, coerce: true }),
      label: z.string({ required_error: errorMessage }).min(1, errorMessage),
    },
    { message: errorMessage },
  );
};
